import Menu from "./modules/menu.js";
import EmailForm from "./modules/email-form.js";

// on document ready
const domReady = () => {

  const docHTML = document.querySelector('html');

  // Setup
  docHTML.classList.remove('no-js');
  docHTML.classList.add('js-ready');

  // Init Main menu - separate file for clarity
  new Menu();
  new EmailForm();
};

if (
  document.readyState === "complete" ||
  (document.readyState !== "loading" && !document.documentElement.doScroll)
) {
  domReady();
} else {
  document.addEventListener("DOMContentLoaded", domReady);
}
